import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { Tab, TabBar } from '#src/atoms/navigation/TabBar/index.tsx';
import { SEARCH_PARAMS } from '#src/components/search/InstantSearch/types.tsx';
import { buildFilterQuery } from '#src/components/search/InstantSearch/utils.ts';
import { useSettlableWalletsSearch } from '#src/hooks/useSettlableWalletsSearch.ts';
import { glossary, navLabels } from '#src/lib/glossary.ts';

type Props = {
  tabs: Record<LeaguePageTabs, string>;
};

export enum LeaguePageTabs {
  OVERVIEW = 'OVERVIEW',
  FIXTURES = 'FIXTURES',
  CARDS = 'CARDS',
}

const tabsTitle: Record<LeaguePageTabs, MessageDescriptor> = {
  [LeaguePageTabs.OVERVIEW]: navLabels.overview,
  [LeaguePageTabs.FIXTURES]: navLabels.fixtures,
  [LeaguePageTabs.CARDS]: glossary.cards,
};

export const Tabs = ({ tabs }: Props) => {
  const defaultSettlementWallets = useSettlableWalletsSearch();
  return (
    <FullWidthContainer.NoPadding>
      <TabBar variant="flat" fullWidth>
        {Object.values(LeaguePageTabs).map(tab => (
          <Tab
            key={tab}
            to={
              tab === LeaguePageTabs.CARDS
                ? `${tabs[tab]}?${buildFilterQuery({
                    [SEARCH_PARAMS.ON_SALE]: true,
                    ...(defaultSettlementWallets
                      ? {
                          [SEARCH_PARAMS.PURCHASE_OPTIONS]:
                            defaultSettlementWallets,
                        }
                      : {}),
                  })}`
                : tabs[tab]
            }
          >
            <FormattedMessage {...tabsTitle[tab]} />
          </Tab>
        ))}
      </TabBar>
    </FullWidthContainer.NoPadding>
  );
};
